import { call, post, patch } from "@/services/api";
import type { Condition, Warehouse } from "@/services/stock";

export type UpcomingContract = {
  contract_id: number; contract_name: string | null; client_name: string | null; event_id: number;
  starts_at: string; type_label: string | null; warehouse: Warehouse | null;
  // The contract's owners at Myotaku, as the feed sends them (office-react 726c561ac).
  sales_reps: { name: string | null; email: string }[];
};
export type Notice = { state: "pending" | "sent" | "failed"; sent_at: string | null; error: string | null };
export type Reservation = {
  id: number; reference: string; status: "sent" | "prepared" | "cancelled";
  myotaku_contract_id: number | null; client_name: string | null; myotaku_warehouse_id: number;
  prepare_on: string | null; deliver_on: string | null; deliver_at: string | null; delivery_type: string | null;
  note: string | null; requested_by: string | null; myotaku_event_id: number | null; created_at: string;
  preparation_title?: string | null; cancelled_at?: string | null; cancelled_by?: string | null;
  prepared_at?: string | null; prepared_by?: string | null;
  // His `cwh`: the warehouse the client is delivered from (a transfer when it is not this one).
  myotaku_client_warehouse_id?: number | null;
  // His resaev `-alert` / `-cancel`: whether the notice reached Emerson and Ludovic on Slack.
  alert?: Notice | null; cancel_notice?: Notice | null;
  pieces: { id: number; reference: string; status: string; condition: Condition; pallet: string | null; rack: string | null;
            unit_number?: number | null; unit_count?: number | null; photo?: { url: string | null; thumb_url: string | null } | null;
            myotaku_product_id: number | null; product: { name: string | null; sku: string | null; image_url: string | null } | null }[];
};


export const fetchUpcomingContracts = () => call<{ contracts: UpcomingContract[]; reaches: string | null }>(`/api/v1/reservations/contracts`);
export const fetchReservations = (o: { warehouseId?: number | null; mine?: boolean; status?: string } = {}) => {
  const q = new URLSearchParams();
  if (o.warehouseId) q.set("warehouse_id", String(o.warehouseId));
  if (o.mine) q.set("mine", "1");
  if (o.status) q.set("status", o.status);
  return call<{ reservations: Reservation[] }>(`/api/v1/reservations${q.toString() ? `?${q}` : ""}`);
};
export const createReservation = (b: Record<string, unknown>) => post<Reservation>(`/api/v1/reservations`, b);
export const updateReservation = (id: number, b: Record<string, unknown>) => patch<Reservation>(`/api/v1/reservations/${id}`, b);
export const reservationPrepared = (id: number) => post<Reservation>(`/api/v1/reservations/${id}/prepared`);
export const cancelReservation = (id: number) => post<Reservation>(`/api/v1/reservations/${id}/cancel`);
